import React, { useEffect, useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import Center from "../../../widget/common/ui/Center";
import { HomeContextImport } from "../../../provider/home/HomeContextProvider";
import StorageKeys from "../../../const/StorageKeys";
import SessionStorage from "../../../service/storage/SessionStorage";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import Loader from "../../../widget/common/ui/Loader";
import Div from "../../../widget/common/ui/Div";
import { imageExtensions, pdfExtensions } from "../../../const/FileExtensions";
import { HomeGuestUserContextImport } from "../../../provider/home_guest_user/guest_home/HomeGuestUserContextProvider";
import { Position } from "../../../widget/common/ui/Stack";

const ProductsBody = (props: { isModal?: boolean | false }) => {
  const isModal: boolean = props.isModal ?? false;

  const guestStatus: string =
    SessionStorage.getValue(StorageKeys.guest_status) || "0";

  // const { getBranchDetail, branchDetail } = HomeContextImport();
  const [loading, setLoading] = useState(true);

  const homeContext = HomeContextImport();
  const homeGuestContext = HomeGuestUserContextImport();

  const [fileExt, setFileExt] = useState<string>("");
  const [fileUrl, setFileUrl] = useState<string>("");

  const getBranchInfo = () => {
    if (guestStatus === "1") {
      homeGuestContext.getBranchDetail();
    } else {
      homeContext.getBranchDetail();
    }
  };

  const initProducts = () => {
    const fileUrlSession: string =
      SessionStorage.getValue(StorageKeys.home_branch_product_url) || "";

    if (UtilityHelper.isEmpty(fileUrlSession)) {
      getBranchInfo();
    } else {
      setFileUrl(fileUrlSession);
      getFileExt(fileUrlSession);
    }
  };

  const getFileExt = (url: string) => {
    const urlArr = url.split(".");
    setFileExt(urlArr[urlArr.length - 1]);
  };

  const handleLoad = () => {
    setLoading(false);
  };

  const loadingHtml: JSX.Element = (
    <Position top={0} left={0} right={0} className="py-5 h-100 w-100 d-center">
      {Loader.normal()}
    </Position>
  );

  useEffect(() => {
    initProducts();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (homeGuestContext.branchDetail != null) {
      const url: string =
        homeGuestContext.branchDetail.branch_products_details?.media_details
          ?.file_url!;
      setFileUrl(url);
      getFileExt(url);
    }
    if (homeContext.branchDetail != null) {
      const url: string =
        homeContext.branchDetail.branch_products_details?.media_details
          ?.file_url!;
      setFileUrl(url);
      getFileExt(url);
    }
  }, [homeGuestContext.branchDetail, homeContext.branchDetail]);

  return (
    <Center className={`h-100 position-relative`}>
      {UtilityHelper.isEmpty(fileUrl) ? (
        <Div className="py-5">{Loader.normal()}</Div>
      ) : (
        <>
          {imageExtensions.includes(fileExt) ? (
            <>
              {loading && loadingHtml}
              <PhotoProvider>
                <PhotoView src={fileUrl}>
                  <img
                    src={fileUrl}
                    style={{ width: `100%`, cursor: "pointer" }}
                    onLoad={handleLoad}
                    alt=""
                  />
                </PhotoView>
              </PhotoProvider>
            </>
          ) : (
            <>
              {pdfExtensions.includes(fileExt) ? (
                <>
                  {loading && loadingHtml}
                  <iframe
                    src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                    width="100%"
                    style={{ height: `${isModal ? 65 : 80}vh` }}
                    onLoad={() => handleLoad()}
                    title="preview"
                  />
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      )}
    </Center>
  );
};

export default ProductsBody;

// "https://www.aeee.in/wp-content/uploads/2020/08/Sample-pdf.pdf";
